import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)
dayjs.extend(timezone)

const APP_TIME_ZONE = "Africa/Nairobi"
const DateFormat = {
  LONG: "D MMMM YYYY",
  SHORT: "D MMM YYYY",
  SHORT_TIME_ZONE: "D MMM YYYY HH:mm [EAT]",
  YEAR_MONTH_DAY: "YYYY-MM-DD",
} as const

export default dayjs

export function formatDate(date: string, format: string = DateFormat.YEAR_MONTH_DAY) {
  return ensureDay(date).format(format)
}

export function formatShortDate(date: string) {
  return formatDate(date, DateFormat.SHORT)
}

export function formatDateRange(startDate: string, endDate: string, format: string = DateFormat.LONG) {
  const fromDate = ensureDay(startDate)
  const toDate = ensureDay(endDate)

  const startFormat = fromDate.isSame(toDate, "month") && fromDate.isSame(toDate, "year") ? "D" : format

  return `${fromDate.format(startFormat)} - ${toDate.format(format)}`
}

export function formatShortDateRange(from: string, to: string) {
  return formatDateRange(from, to, DateFormat.SHORT)
}

export function formatAppDateTime(date: string) {
  return dayjs.utc(date).tz(APP_TIME_ZONE).format(DateFormat.SHORT_TIME_ZONE)
}

export function ensureDay(value: string | dayjs.Dayjs) {
  if (dayjs.isDayjs(value)) return value

  return dayjs.utc(value)
}
